import styled, { css } from 'styled-components'
import { RadioButtonLabelProps, RadioButtonProps, RadioButtonWrapperProps } from './types'
import { FontStyle } from '../../Core/Typography/Font/Font.styles'

const SIZE = {
  s: 20,
  m: 24,
}

export const RadioButtonWrapper = styled.div<RadioButtonWrapperProps>`
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.removeMargins ? '0px' : '8px'};
  ${props =>
    props.marginWrapper &&
    css`
      margin: ${props.marginWrapper || '0'};
    `}
`

export const RadioButtonInput = styled('input')<RadioButtonProps>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 50%;
  margin: 0;
  width: ${props => SIZE?.[props.size]}px;
  min-width: ${props => SIZE?.[props.size]}px;
  max-width: ${props => SIZE?.[props.size]}px;
  height: ${props => SIZE?.[props.size]}px;
  min-height: ${props => SIZE?.[props.size]}px;
  max-height: ${props => SIZE?.[props.size]}px;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  background-color: ${props => props.theme.colors.main.background};
  transition: 0.2s all linear;
  margin-right: 8px;
  position: relative;
  cursor: pointer;

  &:disabled {
    background-color: ${props => props.theme.colors.shades.neutral[0]};
  }

  &:checked {
    border: 6px solid ${props => props.theme.colors.main.ultraViolet};
  }

  &:disabled:checked {
    border: 6px solid ${props => props.theme.colors.shades.neutral[1]};
    background-color: ${props => props.theme.colors.main.background};
  }

   ${props =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth || `${SIZE?.[props.size]}px`};
    `}

  ${props =>
    props.error &&
    css`
      border: 1px solid ${props => props.theme.colors.main.error};
    `}
`

export const RadioButtonLabel = styled.label<RadioButtonLabelProps>`
  margin-right: 15px;
  color: ${props => props.theme.colors.main.dark};
  font-size: 14px;
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  user-select: none;
  ${props =>
    props.display
      ?
      css`
        display: ${props.display};
      `      :
      css`
        display: flex;
        align-content: center;
        align-items: center;
  `}
  ${props =>
    props.ellipsis &&
    css`
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
    `}
`

export const ErrorLabel = styled(FontStyle).attrs({
  as: 'h6',
  tag: 'h6',
  ellipsis: true,
  bold: true,
})`
  color: ${props => props.theme.colors.main.error};
  margin-left: 5px;
`
